
// Open modal when its matching button is clicked
  document.querySelectorAll('.btn-more-info').forEach(btn => {
    // Calculate the scrollbar width
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    btn.addEventListener('click', () => {
      const modalId = btn.getAttribute('data-modal-id');
      const modalOverlay = document.getElementById(modalId);
      if (modalOverlay) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        modalOverlay.classList.add('active');
        document.body.classList.add("noscroll"); // Disable scrolling
      }
    });
  });



  // Close modal when clicking on the overlay (the .outside div)
document.querySelectorAll('.outside').forEach(modal => {
  modal.addEventListener('click', (e) => {
    // only close if the click is on the overlay, not inside .modal-container
    if (e.target === modal) {
      modal.classList.remove('active');
      document.body.classList.remove("noscroll"); // Enable scrolling
      document.body.style.paddingRight = '';
      document.body.style.overflow = '';
    }
  });
});

// Close popup and re-enable background scrolling
document.querySelectorAll('.bubble').forEach(btn => {
  btn.addEventListener('click', () => {
    // Find the closest overlay
    const modalOverlay = btn.closest('.outside');
    if (modalOverlay) {
      modalOverlay.classList.remove('active'); 
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.classList.remove("noscroll"); // Enable scrolling
    }
  });
});

// Optional: close all modals with Escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.outside.active').forEach(modal => {
      modal.classList.remove('active');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.classList.remove("noscroll"); // Enable scrolling
    });
  }
});